/**
 * This type contains helper methods to handle the export of data.
 */

import {ToastManager} from "@/util/ToastManager";

/**
 * Copy all data to clipboard
 * @param t
 * @param toast
 * @param data
 */
export const copyToClipboard = (t: any, toast: any, data: string) => {
	if(navigator && navigator.clipboard) {
		navigator.clipboard.writeText(data)
			.then(() => {
				ToastManager.showSuccess(toast, t('Squeeze.General.Success'), t('Squeeze.General.DataCopied'));
			});
	}
}

/**
 * Download the given content as a file
 * Source: https://stackoverflow.com/questions/3916191/download-data-url-file
 * @param fileName Complete name of the file to save
 * @param content Content of the file
 */
export const downloadFile = (fileName: string, content: string) => {
	const link = document.createElement("a");
	link.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
	link.setAttribute('download', fileName);
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

/**
 * Download all locator data on click of the button, saved as "squeeze_<fileName>.json"
 * @param fileName
 * @param jsonString
 */
export const downloadData = (fileName: string, jsonString: string) => {
	downloadFile('squeeze_' + fileName + ".json", jsonString);
}
